import {Guid} from "guid-typescript";

export class AddActivityBarTransaction {
    ActivityId: string;
    BarId: string;
    Products: {
        Id: string;
        Count: number;
        Price: number;
    }[];

    constructor(eventId: Guid, barId: Guid, items: { id: Guid; count: number, price: number }[]) {
        this.ActivityId = eventId.toString();
        this.BarId = barId.toString();
        this.Products = items.map(item => ({
            Id: item.id.toString(),
            Count: item.count,
            Price: item.price
        }));
    }
}
